/** Normalize order status (hyphens/spaces removed, upper case). */
export function normalizeOnlineOrderStatusForFilter(raw) {
    return String(raw ?? '')
        .trim()
        .toUpperCase()
        .replace(/[\s_-]+/g, '');
}

/** Map displayed / stored order status to backend update_order.order_status_code. */
export function onlineDisplayStatusToOrderStatusCode(raw) {
    const norm = normalizeOnlineOrderStatusForFilter(raw);
    const map = {
        NEW: 'NEW',
        ACC: 'ACC',
        ACCEPTED: 'ACC',
        PREPARING: 'PREP',
        PREP: 'PREP',
        READY: 'RDY',
        RDY: 'RDY',
        OUTFORDELIVERY: 'OFD',
        OFD: 'OFD',
        PICKEDUP: 'PU',
        PU: 'PU',
        SERVED: 'SRV',
        SRV: 'SRV',
        DELIVERED: 'DEL',
        CANCELLED: 'CAN',
        COMPLETED: 'CMP',
        CMP: 'CMP',
        UNDELIVERED: 'UND',
        UND: 'UND',
        INTRANSIT: 'OFD',
        INTRANST: 'OFD',
    };
    return map[norm] || 'ACC';
}

/** Courier UI options — same wording as TodayOrder online status modal. */
export const DELIVERY_AGENT_STATUS_OPTIONS = [
    { value: 'OUT-FOR-DELIVERY', label: 'OUT-FOR-DELIVERY' },
    { value: 'DELIVERED', label: 'DELIVERED' },
];

/**
 * Maps any API/display order status to the courier dropdown value (controlled select).
 */
export function orderStatusToCourierDropdownValue(raw) {
    const code = onlineDisplayStatusToOrderStatusCode(raw);
    if (code === 'DEL') return 'DELIVERED';
    return 'OUT-FOR-DELIVERY';
}

/**
 * Order rows from /delivery-agent/orders may expose status under different keys — use the first present.
 */
export function resolveOrderStatusRaw(order) {
    if (!order || typeof order !== 'object') return '';
    const v =
        order.OrderStatus ??
        order.orderStatus ??
        order.Order_Status ??
        order.order_status ??
        order.Status ??
        order.status ??
        order.OrderStatusCode ??
        order.orderStatusCode ??
        order.order_status_code ??
        order.Order_Status_Code ??
        '';
    return String(v).trim();
}
